export const FIELD_SIZE_XS = 0;
export const FIELD_SIZE_SM = 1;
export const FIELD_SIZE_MD = 2;
export const FIELD_SIZE_LG = 3;
export const FIELD_SIZE_XL = 4;

export const FIELD_SIZE_FULL = 5;

export const FIELD_SIZES = [
    { value: FIELD_SIZE_XS, label: "Очень короткое" },
    { value: FIELD_SIZE_SM, label: "Короткое" },
    { value: FIELD_SIZE_MD, label: "Среднее" },
    { value: FIELD_SIZE_LG, label: "Длинное" },
    { value: FIELD_SIZE_XL, label: "Очень длинное" },
];

export const SIZE_NAMES = {
    [FIELD_SIZE_XS]: "xs",
    [FIELD_SIZE_SM]: "sm",
    [FIELD_SIZE_MD]: "md",
    [FIELD_SIZE_LG]: "lg",
    [FIELD_SIZE_XL]: "xl",
    [FIELD_SIZE_FULL]: "full",
};
